"use client";

import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { Item } from "@/types/common";
import { SelectOptionsDataType } from "@/constants/common";
import { useSelectsOptionsFetchers } from "@/hooks/useSelectsOptionsFetchers";

export interface MyReportingProviderProps {
  children: ReactNode;
  bannersAreLoaded: boolean;
}

type MyReportingType = {
  activityTypes: Item[];
  loading: boolean;
  bannersAreLoaded: boolean;
  menuCollapsed: boolean;
  setMenuCollapsed: Dispatch<SetStateAction<boolean>>;
};

const MyReportingContext = createContext<MyReportingType>({
  activityTypes: [],
  loading: false,
  bannersAreLoaded: false,
  menuCollapsed: false,
  setMenuCollapsed: () => undefined,
});

export const MyReportingProvider: React.FC<MyReportingProviderProps> = ({ children, bannersAreLoaded }) => {
  const { fetchSelectOptions } = useSelectsOptionsFetchers();

  const [activityTypes, setActivityTypes] = useState<Item[]>([]);
  const [loading, setLoading] = useState(true);
  const [menuCollapsed, setMenuCollapsed] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await fetchSelectOptions({ dataType: SelectOptionsDataType.activityTypes, setIsLoading: setLoading });

      setActivityTypes(data);
      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <MyReportingContext.Provider value={{ activityTypes, loading, bannersAreLoaded, menuCollapsed, setMenuCollapsed }}>
      {children}
    </MyReportingContext.Provider>
  );
};

export const useMyReportingTabs = () => useContext(MyReportingContext);
